import { Box, Tooltip as TooptipLib, useTheme } from '@chakra-ui/react';
import { FC } from 'react';
import { ChakraTooltipProps } from './types';

const Tooltip: FC<ChakraTooltipProps> = ({
  placement,
  label,
  padding,
  labelProps = {},
  dataTestId,
  ...props
}) => {
  const chakraTheme = useTheme();
  const { mediumGrey, white } = chakraTheme.colors;

  return (
    <TooptipLib
      borderRadius='3px'
      fontSize='14px'
      lineHeight='19px'
      textAlign='left'
      zIndex={60}
      color={mediumGrey}
      boxShadow={chakraTheme.shadow.mediumShadow}
      placement={placement || 'top'}
      padding={padding}
      bg={chakraTheme.colors?.mediumGrey}
      data-testid={dataTestId || 'cj-tooltip'}
      maxWidth='inherit'
      hasArrow
      label={
        <Box
          as='div'
          py='8px'
          px='16px'
          fontFamily={chakraTheme.fonts.regular}
          color={white}
          textAlign='left'
          {...labelProps}
        >
          {label}
        </Box>
      }
      {...props}
    />
  );
};

export default Tooltip;
